import { useCallback, useEffect, useState } from 'react'
import { Button, Select, Space, Card, Row, Col, Typography, Tag } from 'antd';
import { EyeOutlined, EditOutlined, TeamOutlined, PercentageOutlined } from '@ant-design/icons';
import { apiGetListPackageDataCodes } from "../../api";
import { useLoading } from '../../context/LoadingContext';
import { formatCurrency } from '../../utils/string-utils';
import { Link } from 'react-router-dom';
import { CREATE_PACKAGES_CODE, EDIT_PACKAGES_CODE, PACKAGES } from '../../assets/constants/route_path';
import ViewPackagesCode from './ViewPackagesCode';
import { formatDate } from '../../utils/entity-utils';
import { partnerPackageDataCodeSourceOptions } from '../../assets/constants/default_option';

const { Title, Text } = Typography;

export default function TabPackagesCode() {
    const [codes, setCodes] = useState<any>({})
    const [source, setSource] = useState('')
    const [modalView, setModalView] = useState<{ data: any, isOpen: boolean }>({
        data: null,
        isOpen: false,
    })

    const { setIsLoading } = useLoading()

    const fetchDataCode = useCallback(async () => {
        try {
            setIsLoading(true)
            const resCodes = await apiGetListPackageDataCodes({ source })
            if (resCodes.data.dataCodes != null) {
                if (source) {
                    const listSponsor = {} as any
                    const listSponsorBySource = resCodes.data?.dataCodes?.filter((item: any) => item.source === source)
                    listSponsor.dataCodes = listSponsorBySource
                    listSponsor.total = listSponsorBySource?.length
                    setCodes(listSponsor)
                } else {
                    setCodes(resCodes.data)
                }
            } else {
                setCodes({})
            }
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            console.log(error)
        }
    }, [source])

    useEffect(() => {
        fetchDataCode()
    }, [fetchDataCode])

    const renderCodeCard = (code: any, index: number) => (
        <Card
            key={code.ID || index}
            style={{
                marginBottom: 16,
                border: '1px solid #f0f0f0',
                borderRadius: 8
            }}
        >
            <Row justify="space-between" align="top">
                <Col span={24}>
                    <div style={{ marginBottom: 12 }}>
                        <Row justify="space-between" align="middle">
                            <Col>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                    <div style={{
                                        width: 32,
                                        height: 32,
                                        borderRadius: '50%',
                                        backgroundColor: '#1890ff',
                                        color: 'white',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        fontWeight: 'bold',
                                        fontSize: '14px'
                                    }}>
                                        {index + 1}
                                    </div>
                                    <div>
                                        <Title level={5} style={{ margin: 0, marginBottom: 4 }}>
                                            {code.name}
                                        </Title>
                                        <Text type="secondary">
                                            {code.dataCode}
                                        </Text>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>

                    <Row gutter={24} style={{ marginBottom: 16 }}>
                        <Col span={4}>
                            <div>
                                <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>DATA CODE MODEL ID</Text>
                                <div style={{ marginTop: 4 }}>
                                    <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                        {code.dataCodeModelId}
                                    </Text>
                                </div>
                            </div>
                        </Col>
                        <Col span={4}>
                            <div>
                                <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>GIÁ</Text>
                                <div style={{ marginTop: 4 }}>
                                    <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                        {formatCurrency(code.priceUnit)}
                                    </Text>
                                </div>
                            </div>
                        </Col>
                        <Col span={4}>
                            <div>
                                <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>NGUỒN</Text>
                                <div style={{ marginTop: 4 }}>
                                    <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                        {code.source}
                                    </Text>
                                </div>
                            </div>
                        </Col>
                        <Col span={4}>
                            <div>
                                <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>LOẠI</Text>
                                <div style={{ marginTop: 4 }}>
                                    <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                        {code.type}
                                    </Text>
                                </div>
                            </div>
                        </Col>
                        <Col span={4}>
                            <div>
                                <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>TRẠNG THÁI</Text>
                                <div style={{ marginTop: 4 }}>
                                    <Tag color="green" style={{ fontSize: '11px' }}>
                                        {code.status}
                                    </Tag>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        marginTop: 12,
                        padding: '12px',
                        backgroundColor: '#fafafa',
                        borderRadius: 6,
                        border: '1px solid #f0f0f0'
                    }}>
                        <div>
                            <Text strong style={{ color: '#8c8c8c', fontSize: '12px' }}>THỜI GIAN TẠO</Text>
                            <div style={{ marginTop: 4 }}>
                                <Text style={{ fontSize: '14px', fontWeight: 500 }}>
                                    {code.CreatedAt ? formatDate(code.CreatedAt) : ''}
                                </Text>
                            </div>
                        </div>
                        <Space>
                            <Button
                                onClick={() => setModalView({ data: code, isOpen: true })}
                                style={{ color: 'white', background: 'gray' }}
                                icon={<EyeOutlined />}>
                            </Button>
                            <Link to={PACKAGES + EDIT_PACKAGES_CODE + `?id=${code.ID}`}>
                                <Button
                                    style={{ color: 'white', background: 'orange' }}
                                    icon={<EditOutlined />}>
                                </Button>
                            </Link>
                        </Space>
                    </div>
                </Col>
            </Row>
        </Card>
    )

    const codePackages = codes?.dataCodes || []
    const totalCodes = codePackages.length
    const activeCodes = codePackages.filter((code: any) => code.status === 'Active').length
    const avgPrice = totalCodes > 0 ? (codePackages.reduce((acc: number, pkg: any) => acc + (pkg.priceUnit || 0), 0) / totalCodes) : 0

    return (
        <>
            {/* Statistics Header */}
            <Row gutter={24} style={{ marginBottom: 24 }}>
                <Col span={6}>
                    <Card>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                            <div style={{
                                width: 40,
                                height: 40,
                                borderRadius: 8,
                                backgroundColor: '#e6f7ff',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <TeamOutlined style={{ color: '#1890ff', fontSize: '20px' }} />
                            </div>
                            <div>
                                <Text type="secondary">Total Codes</Text>
                                <div>
                                    <Title level={3} style={{ margin: 0, color: '#1890ff' }}>
                                        {totalCodes}
                                    </Title>
                                </div>
                            </div>
                        </div>
                    </Card>
                </Col>
                <Col span={6}>
                    <Card>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                            <div style={{
                                width: 40,
                                height: 40,
                                borderRadius: 8,
                                backgroundColor: '#f6ffed',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <TeamOutlined style={{ color: '#52c41a', fontSize: '20px' }} />
                            </div>
                            <div>
                                <Text type="secondary">Active Codes</Text>
                                <div>
                                    <Title level={3} style={{ margin: 0, color: '#52c41a' }}>
                                        {activeCodes}
                                    </Title>
                                </div>
                            </div>
                        </div>
                    </Card>
                </Col>
                <Col span={6}>
                    <Card>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                            <div style={{
                                width: 40,
                                height: 40,
                                borderRadius: 8,
                                backgroundColor: '#fff7e6',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <PercentageOutlined style={{ color: '#fa8c16', fontSize: '20px' }} />
                            </div>
                            <div>
                                <Text type="secondary">Avg Price</Text>
                                <div>
                                    <Title level={3} style={{ margin: 0, color: '#fa8c16' }}>
                                        {avgPrice > 0 ? formatCurrency(avgPrice) : '0'}
                                    </Title>
                                </div>
                            </div>
                        </div>
                    </Card>
                </Col>
            </Row>

            <Row gutter={16} style={{ marginBottom: 24 }}>
                <Col span={4}>
                    <div>
                        <Text strong>Chọn nguồn</Text>
                        <Select
                            style={{ width: '100%', marginTop: 4 }}
                            placeholder="Chọn nguồn"
                            value={source}
                            onChange={(value) => setSource(value || '')}
                            options={[
                                { label: 'Tất cả', value: '' },
                                ...partnerPackageDataCodeSourceOptions,
                            ]}
                        />
                    </div>
                </Col>
                <Col span={20}>
                    <div style={{ marginTop: 24, textAlign: 'right' }}>
                        <Link to={PACKAGES + CREATE_PACKAGES_CODE}>
                            <Button type="primary">
                                Thêm gói cước
                            </Button>
                        </Link>
                    </div>
                </Col>
            </Row>

            {codePackages.length > 0 ? (
                <div>
                    {codePackages.map((code: any, index: number) => renderCodeCard(code, index))}
                </div>
            ) : (
                <Card>
                    <div style={{ textAlign: 'center', padding: '40px 0' }}>
                        <Title level={4} type="secondary">
                            No Data Code Packages Found
                        </Title>
                        <Text type="secondary">
                            Configure data code packages
                        </Text>
                    </div>
                </Card>
            )}

            <ViewPackagesCode
                modalView={modalView}
                setModalView={setModalView}
            />
        </>
    )
}
